module.exports = __webpack_public_path__ + "427d914108ce4d0cca3c84733fa6ee43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-heart-s.png
// module id = 2335
// module chunks = 0